import { render, staticRenderFns } from "./NotifikacijaCreate.vue?vue&type=template&id=2b67b08f&scoped=true&"
import script from "./NotifikacijaCreate.vue?vue&type=script&lang=js&"
export * from "./NotifikacijaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67b08f",
  null
  
)

export default component.exports